import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// eslint-disable-next-line import/default
import detailsMixin from './detailsMixin';
export default {
  name: 'NiotaClassicGwMgmtDetailsForm',
  mixins: [detailsMixin],
  data: function data() {
    return {};
  },
  methods: {
    formatLastPacketTime: function formatLastPacketTime(duration) {
      var durationHours = Math.floor(duration);
      var durationMinutes = Math.round(duration * 60) - durationHours * 60;
      var hoursString = this.$i18n_tc('NiotaClassic.GWMonitoring.hours', durationHours, {
        n: durationHours
      });
      var minutesString = this.$i18n_tc('NiotaClassic.GWMonitoring.minutes', durationMinutes, {
        n: durationMinutes
      });

      if (durationMinutes > 0 && durationHours < 24) {
        return "".concat(hoursString, " ").concat(minutesString);
      }

      return hoursString;
    },
    copyToClipboard: function copyToClipboard(event, data) {
      var value = '';

      if (_typeof(data) === 'object' && data !== null) {
        value = JSON.stringify(data);
      } else if (typeof data === 'string') {
        value = data;
      }

      event.stopPropagation(); // create textarea to copy from

      var copyElement = document.createElement('textarea');
      copyElement.value = value; // set styles to hide textarea from viewport

      copyElement.style.position = 'absolute';
      copyElement.style.top = '-99999px'; // add to element to body otherwise we can't select/copy

      document.body.appendChild(copyElement); // copy text

      copyElement.select();
      document.execCommand('copy'); // remove element

      copyElement.remove();
    }
  }
};